import { RenderContent } from 'components/content-renderer';
import { Layout } from 'components/layout';
import {
  GetPageContentDocument,
  GetPageContentQueryVariables,
  useGetPageContentQuery,
} from 'lib/graphql-generated';
import { addApolloState, initializeApollo } from 'lib/hooks/apollo-client';
import { GetServerSideProps } from 'next';

const PAGE_TITLE = 'terms';

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const client = initializeApollo();

  await client.query({
    query: GetPageContentDocument,
    variables: {
      title: PAGE_TITLE,
    } as GetPageContentQueryVariables,
  });

  return addApolloState(client, {
    props: {},
  });
};

export const TermsPage = () => {
  const { data } = useGetPageContentQuery({
    variables: {
      title: PAGE_TITLE,
    },
  });

  return (
    <Layout pageName='T&C'>
      <article className='prose px-4 2xl:px-0 mx-auto'>
        <RenderContent content={data.pages_by_pk.content.data[0].data} />
      </article>
    </Layout>
  );
};

export default TermsPage;
